export default __webpack_public_path__ + "static/media/ce1.ffdc94ed.jpeg";